import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "wouter";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

/** Historical applications may predate salary offers. Resolve their recorded
 * engagement explicitly; navigation never creates a preparation or a hire. */
export function EmploymentLink({ applicationId, engagementId }: { applicationId: string; engagementId?: string | null }) {
  const { user } = useAuth();
  return <ScopedEmploymentLink key={`${applicationId}:${user?.id}:${user?.activeContext}`} applicationId={applicationId} engagementId={engagementId} />;
}
function ScopedEmploymentLink({ applicationId, engagementId }: { applicationId: string; engagementId?: string | null }) {
  const [, navigate] = useLocation(), live = useRef(true), [error, setError] = useState(""), [busy, setBusy] = useState(false);
  useEffect(() => { live.current = true; return () => { live.current = false; }; }, []);
  if (engagementId) return <Link href={`/contracts?engagement=${encodeURIComponent(engagementId)}&tab=agreement`} className="text-sm font-semibold text-blue-700 hover:underline">Employment agreement</Link>;
  async function open() {
    setBusy(true); setError("");
    try { const found = await api.employmentForApplication(applicationId); if (live.current) navigate(`/contracts?engagement=${encodeURIComponent(found.engagementId)}&tab=agreement`); }
    catch (failure: unknown) { if (live.current) setError(failure instanceof Error ? failure.message : "Could not open this Employment record. Retry."); }
    finally { if (live.current) setBusy(false); }
  }
  return <span className="block"><button type="button" className="min-h-9 text-sm font-semibold text-blue-700 hover:underline disabled:opacity-50" disabled={busy} onClick={() => void open()}>{busy ? "Opening Employment…" : "Employment agreement"}</button>{error && <span role="alert" className="mt-1 block text-xs text-brand-red">{error}</span>}</span>;
}
